function formSelect() {
    jQuery(".gform_wrapper select:not([multiple='multiple'])").select2({
        minimumResultsForSearch: Infinity,
    });
    jQuery(".calendar-hero select:not([multiple='multiple'])").select2({
        minimumResultsForSearch: Infinity,
    });
}

export default formSelect;
